import { useAtomValue } from 'jotai';
import { FilterValues } from '../constants';
import { messagesFilterAtom } from '../store';

export default function useMessagesFilterSelectedValues() {
  const filterValue = useAtomValue(messagesFilterAtom);

  const isAllFilterSelected = filterValue.value === FilterValues.all;
  const isArchiveFilterSelected = filterValue.value === FilterValues.archived;
  const isReadMessagesFilterSelected = filterValue.value === FilterValues.read;
  const isUnreadMessagesFilterSelected = filterValue.value === FilterValues.unread;

  return { isAllFilterSelected, isArchiveFilterSelected, isReadMessagesFilterSelected, isUnreadMessagesFilterSelected };
}
